module.exports = __webpack_public_path__ + "static/img/qrcode.7967558.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/module/home/img/qrcode.jpg
// module id = ik0k
// module chunks = 1 18 25 34 93 95 96 97 98 99 100 101 102